import DOMPurify from "dompurify";

// Centralized sanitizer for admin-authored HTML content rendered via dangerouslySetInnerHTML.
// Allows the basic tags admins need for news / info / prizes pages.
const ALLOWED_TAGS = [
  "h2", "h3", "h4", "p", "ul", "ol", "li", "strong", "em", "b", "i",
  "a", "br", "blockquote", "code", "pre", "table", "thead", "tbody", "tr", "th", "td",
  "hr", "span", "div",
];
const ALLOWED_ATTR = ["href", "target", "rel", "class", "id", "title"];

export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "style"],
  });
}
